import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations";

export const Services = (props) => {
  const { language } = useLanguage();
  const t = translations.services[language] || translations.services.en;

  const services = [
    { icon: "📱", ...t.service1 },
    { icon: "💻", ...t.service2 },
    { icon: "⚡", ...t.service3 },
    { icon: "☁️", ...t.service4 },
    { icon: "🎨", ...t.service5 },
    { icon: "🔧", ...t.service6 }
  ];

  return (
    <section id="services">
      <div className="container">
        <div className="section-header">
          <span className="section-label">{t.title}</span>
          <h2 className="section-title">{t.title}</h2>
          <p className="section-description">
            {t.subtitle}
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, i) => (
            <div key={i} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
